import {
  FilterMode,
  Theme_OrderBy,
  Theme,
  SortOrder,
  Theme_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const themeService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.themeOne({ id });
    return result.themeOne as Theme;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: Theme_OrderBy[] | null = null,
    filter: Theme_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: Theme_Filter | undefined;
    if (searchValue !== "") {
      where = { name: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.themeListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ name: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.themeListWithOffset
    ) as Theme[];
    return { list, orderBy };
  },
};
